import { deleteCameraType2 } from "actions/Utilities/CameraType2";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { cameraType2ReFetching } from "../atoms/atoms";

export default function useDeleteCameraType2() {
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType2ReFetching);
  const { mutate } = useMutation((ids: number[]) => deleteCameraType2(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Camera Type 2 failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Camera Type 2 Disabled Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Camera Type 2 Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Camera Type 2 failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Camera Type 2 not found":
            toast.fire(
              "Disabling Camera Type 2 failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Disabling Camera Type 2 failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Camera Type 2 failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
